import $ from 'jquery';
window.$ = window.jQuery = $;

class ProfetTabbedContent {
	constructor() {}
	init() {
		let tabbedContentButtons = document.querySelectorAll('.tabbed-content-navigation-button');
		if (!tabbedContentButtons.length) {
			return;
		}

		/* Handle clicks on [data-toggle-display] elements */
		let slideToggleLinks = document.querySelectorAll('[data-toggle-display]');
		if (slideToggleLinks) {
			slideToggleLinks.forEach((item) => {
				item.addEventListener('click', function (event) {
					event.preventDefault();
					item.classList.toggle('active');
					let targetId = item.getAttribute('data-toggle-display');
					if (!targetId) {
						return;
					}
					$(targetId).slideToggle();
				});
			});
		}

		tabbedContentButtons.forEach((button) => {
			button.addEventListener('click', function (event) {
				event.preventDefault();

				/* Hide all tabbed content items and unset the .active class on all navigation buttons ... */
				let parentWrapper = this.closest('.tabbed-content');
				if (parentWrapper) {
					let contentItems = parentWrapper.querySelectorAll('.tabbed-content-item');
					if (contentItems) {
						contentItems.forEach((item) => {
							item.classList.remove('active');
						});
					}
					let navigationButtons = parentWrapper.querySelectorAll('.tabbed-content-navigation-button');
					if (navigationButtons) {
						navigationButtons.forEach((item) => {
							item.classList.remove('active');
						});
					}
				}
				this.classList.add('active');

				/* Display only the tabbed content item we want to display... */
				let targetId = this.getAttribute('data-toggle-tabbed-content-id');
				if (!targetId) {
					return;
				}
				let target = document.querySelector(`[data-tabbed-content-id="${targetId}"`);
				if (target) {
					target.classList.add('active');
				}
			});
		});
	}
}
window.addEventListener('load', () => {
	window.ProfetTabbedContent = new ProfetTabbedContent();
	window.ProfetTabbedContent.init();
});

window.addEventListener('load', () => {});
